import React from "react";

import Automative from "./Automotive";

import Consumer from "./Consumer";
import Retail from "./Retail";
import Public from "./Public";
import Energy from "./Engergy";

const Details = (props) => {
  return (
    <>
      <div className="">
        {props.active === "Automotive" ? <Automative {...props} /> : null}
        {props.active === "Consumer Products" ? <Consumer {...props} /> : null}
        {props.active === "Retail" ? <Retail {...props} /> : null}
        {props.active === "Public sector" ? <Public {...props} /> : null}
        {props.active === "Energy" ? <Energy {...props} /> : null}
      </div>
    </>
  );
};

export default Details;
